import { render, staticRenderFns } from "./submission_details.vue?vue&type=template&id=2135b583&scoped=true&"
import script from "./submission_details.vue?vue&type=script&lang=js&"
export * from "./submission_details.vue?vue&type=script&lang=js&"
import style0 from "./submission_details.vue?vue&type=style&index=0&id=2135b583&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2135b583",
  null
  
)

export default component.exports